import { TadbirFund } from "../hooks/useFunds";

export interface StaticFundMetric {
  title: string;
  value: string;
  helper: string;
}

export interface StaticFundBenefit {
  title: string;
  description: string;
}

export interface StaticFundFaq {
  question: string;
  answer: string;
}

export interface StaticFundContent {
  slug: string;
  updatedAt: string;
  lastTradePrice: string;
  closingPrice: string;
  averageAnnualReturn: string;
  heroSubtitle: string;
  summary: string;
  chips: string[];
  benefitsTitle: string;
  suitabilityTitle: string;
  suitabilitySubtitle: string;
  metrics: StaticFundMetric[];
  benefits: StaticFundBenefit[];
  faqs: StaticFundFaq[];
  investUrl: string;
  websiteUrl: string;
}

export interface PublicStaticFund extends TadbirFund {
  staticContent: StaticFundContent;
}

export const isPublicStaticFund = (
  fund: TadbirFund | PublicStaticFund,
): fund is PublicStaticFund => "staticContent" in fund;

export const getPublicStaticFundBySlug = (
  funds: Array<TadbirFund | PublicStaticFund> = [],
  fundId?: string,
) => {
  const normalizedFundId = fundId?.replace(/-/g, "");

  return funds.find((fund) => {
    if (!isPublicStaticFund(fund)) {
      return false;
    }

    const normalizedSlug = fund.staticContent.slug.replace(/-/g, "");
    const normalizedRegisterCode = fund.fundRegisterCode.replace(/-/g, "");

    return (
      fund.staticContent.slug === fundId ||
      fund.fundRegisterCode === fundId ||
      normalizedSlug === normalizedFundId ||
      normalizedRegisterCode === normalizedFundId
    );
  }) as PublicStaticFund | undefined;
};

export const getPublicStaticFundRoute = (
  fund: TadbirFund | PublicStaticFund,
) =>
  isPublicStaticFund(fund) ? fund.staticContent.slug : fund.fundRegisterCode;
